import Api_Usermanagement from '../api-usermanagement'
import Api_Masterdata from '../api-masterdata'

const api = new Api_Usermanagement().init()
const api_masterdata = new Api_Masterdata().init()

const getAllInvoice = () => {
  return api.get(`/invoice-sales-order?credentials=${localStorage.getItem('credential')}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const updateInvoice = (id, data) => {
  return api.put(`/invoice-sales-order/update-invoice-date/${id}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const synchronizeInvoice = (data) => {
  return api.post(`/invoice-sales-order/syc-from-sap`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const resendToSAP = (id, data) => {
  return api.put(`/invoice-sales-order/resend-to-sap/${id}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

export {getAllInvoice, updateInvoice, synchronizeInvoice, resendToSAP}
